import antdNotificationService from './antdNotificationService'

export { AntdNotificationService } from './antdNotificationService'

export default antdNotificationService
